var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    width: 21,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10,
    height: 10,
    fill: "#f25022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 0,
    width: 10,
    height: 10,
    fill: "#7fba00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11,
    width: 10,
    height: 10,
    fill: "#00a4ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 10,
    height: 10,
    fill: "#ffb900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/microsoft-logo.4e756e9bebdfb16e5def11ada7b57979.svg";
export { ForwardRef as ReactComponent };